import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import REDButton from "../components/red/REDButton";
import REDInput from "../components/red/REDInput";
import REDCustomSelect from "../components/red/REDCustomSelect";
import REDCheckbox from "../components/red/REDCheckbox";
import REDSection from "../components/red/REDSection";
import { DBNotification } from "@db-ux/react-core-components";
import { submitForm } from "../services/formApi";
import {
  validateEmail,
  validatePhone,
  validatePostalCode,
  validateMaxLength,
  FIELD_LIMITS,
} from "../utils/validationRules";

// Countries configuration
const COUNTRIES = {
  de: [
    // Priority countries first
    { value: "Deutschland", label: "Deutschland" },
    { value: "Schweiz", label: "Schweiz" },
    { value: "Oesterreich", label: "Österreich" },
    // All other countries alphabetically
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Aegypten", label: "Ägypten" },
    { value: "Albanien", label: "Albanien" },
    { value: "Algerien", label: "Algerien" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Argentinien", label: "Argentinien" },
    { value: "Armenien", label: "Armenien" },
    { value: "Aserbaidschan", label: "Aserbaidschan" },
    { value: "Aethiopien", label: "Äthiopien" },
    { value: "Australien", label: "Australien" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesch", label: "Bangladesch" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgien", label: "Belgien" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivien", label: "Bolivien" },
    { value: "BosnienHerzegowina", label: "Bosnien-Herzegowina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brasilien", label: "Brasilien" },
    { value: "Brunei", label: "Brunei Darussalam" },
    { value: "Bulgarien", label: "Bulgarien" },
    { value: "BurkinaFaso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "CostaRica", label: "Costa Rica" },
    { value: "Daenemark", label: "Dänemark" },
    { value: "Dominica", label: "Dominica" },
    { value: "DominikanischeRepublik", label: "Dominikanische Republik" },
    { value: "Dschibuti", label: "Dschibuti" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Elfenbeinkueste", label: "Elfenbeinküste" },
    { value: "ElSalvador", label: "El Salvador" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estland", label: "Estland" },
    { value: "Fidschi", label: "Fidschi" },
    { value: "Finnland", label: "Finnland" },
    { value: "Frankreich", label: "Frankreich" },
    { value: "Gabun", label: "Gabun" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgien", label: "Georgien" },
    { value: "Ghana", label: "Ghana" },
    { value: "Gibraltar", label: "Gibraltar" },
    { value: "Grenada", label: "Grenada" },
    { value: "Griechenland", label: "Griechenland" },
    { value: "Grossbritannien", label: "Großbritannien u. Nordirland" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "GuineaBissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hongkong", label: "Hongkong" },
    { value: "Indien", label: "Indien" },
    { value: "Indonesien", label: "Indonesien" },
    { value: "Irak", label: "Irak" },
    { value: "Iran", label: "Iran, Islamische Republik" },
    { value: "Irland", label: "Irland" },
    { value: "Island", label: "Island" },
    { value: "Israel", label: "Israel" },
    { value: "Italien", label: "Italien" },
    { value: "Jamaika", label: "Jamaika" },
    { value: "Japan", label: "Japan" },
    { value: "Jemen", label: "Jemen" },
    { value: "Jordanien", label: "Jordanien" },
    { value: "Kambodscha", label: "Kambodscha" },
    { value: "Kamerun", label: "Kamerun" },
    { value: "Kanada", label: "Kanada" },
    { value: "KapVerde", label: "Kap Verde" },
    { value: "Kasachstan", label: "Kasachstan" },
    { value: "Kenia", label: "Kenia" },
    { value: "Kirgisistan", label: "Kirgisistan" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Kolumbien", label: "Kolumbien" },
    { value: "Komoren", label: "Komoren" },
    { value: "Kongo", label: "Kongo" },
    { value: "Kroatien", label: "Kroatien" },
    { value: "Kuba", label: "Kuba" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Laos", label: "Laos" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Lettland", label: "Lettland" },
    { value: "Libanon", label: "Libanon" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libyen", label: "Libyen" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Litauen", label: "Litauen" },
    { value: "Luxemburg", label: "Luxemburg" },
    { value: "Madagaskar", label: "Madagaskar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Malediven", label: "Malediven" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marokko", label: "Marokko" },
    { value: "MarshallInseln", label: "Marshall-Inseln" },
    { value: "Mauretanien", label: "Mauretanien" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mexiko", label: "Mexiko" },
    { value: "Mikronesien", label: "Mikronesien" },
    { value: "Moldawien", label: "Moldawien" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolei", label: "Mongolei" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Mosambik", label: "Mosambik" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Neuseeland", label: "Neuseeland" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niederlande", label: "Niederlande" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    {
      value: "Nordkorea",
      label: "Korea, Demokratische Volksrepublik (Nordkorea)",
    },
    { value: "Norwegen", label: "Norwegen" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Panama", label: "Panama" },
    { value: "PapuaNeuguinea", label: "Papua-Neuguinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippinen", label: "Philippinen" },
    { value: "Polen", label: "Polen" },
    { value: "Portugal", label: "Portugal" },
    { value: "Ruanda", label: "Ruanda" },
    { value: "Rumaenien", label: "Rumänien" },
    { value: "Russland", label: "Russland" },
    { value: "Sambia", label: "Sambia" },
    { value: "Samoa", label: "Samoa" },
    { value: "SanMarino", label: "San Marino" },
    { value: "SantaLucia", label: "Santa Lucia" },
    { value: "SaoTome", label: "Sao Tome" },
    { value: "SaudiArabien", label: "Saudi-Arabien" },
    { value: "Schweden", label: "Schweden" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbien", label: "Serbien" },
    { value: "Seychellen", label: "Seychellen" },
    { value: "SierraLeone", label: "Sierra Leone" },
    { value: "Simbabwe", label: "Simbabwe" },
    { value: "Singapur", label: "Singapur" },
    { value: "Slowakei", label: "Slowakei" },
    { value: "Slowenien", label: "Slowenien" },
    { value: "Somalia", label: "Somalia" },
    { value: "Spanien", label: "Spanien" },
    { value: "SriLanka", label: "Sri Lanka" },
    { value: "Suedafrika", label: "Südafrika" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suedkorea", label: "Korea, Republik (Südkorea)" },
    { value: "Surinam", label: "Suriname" },
    { value: "Syrien", label: "Syrien" },
    { value: "Tadschikistan", label: "Tadschikistan" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tansania", label: "Tansania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tonga", label: "Tonga" },
    { value: "TrinidadUndTobago", label: "Trinidad und Tobago" },
    { value: "Tschad", label: "Tschad" },
    { value: "Tschechien", label: "Tschechien" },
    { value: "Tunesien", label: "Tunesien" },
    { value: "Tuerkei", label: "Türkei" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "Ungarn", label: "Ungarn" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Usbekistan", label: "Usbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatikanstadt", label: "Vatikanstadt" },
    { value: "Venezuela", label: "Venezuela" },
    {
      value: "VereinigteArabischeEmirate",
      label: "Vereinigte Arabische Emirate",
    },
    {
      value: "VereinigteStaatenVonAmerica",
      label: "Vereinigte Staaten von America",
    },
    { value: "Vietnam", label: "Vietnam" },
    {
      value: "ZentralafrikanischeRepublik",
      label: "Zentralafrikanische Republik",
    },
    { value: "Zypern", label: "Zypern" },
  ],
  en: [
    // Priority countries first
    { value: "Deutschland", label: "Germany" },
    { value: "Schweiz", label: "Switzerland" },
    { value: "Oesterreich", label: "Austria" },
    // All other countries alphabetically
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Aegypten", label: "Egypt" },
    { value: "Albanien", label: "Albania" },
    { value: "Algerien", label: "Algeria" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Argentinien", label: "Argentina" },
    { value: "Armenien", label: "Armenia" },
    { value: "Aserbaidschan", label: "Azerbaijan" },
    { value: "Aethiopien", label: "Ethiopia" },
    { value: "Australien", label: "Australia" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesch", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgien", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivien", label: "Bolivia" },
    { value: "BosnienHerzegowina", label: "Bosnia Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Brasilien", label: "Brazil" },
    { value: "Brunei", label: "Brunei" },
    { value: "Bulgarien", label: "Bulgaria" },
    { value: "BurkinaFaso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "CostaRica", label: "Costa Rica" },
    { value: "Daenemark", label: "Denmark" },
    { value: "Dominica", label: "Dominica" },
    { value: "DominikanischeRepublik", label: "Dominican Republic" },
    { value: "Dschibuti", label: "Djibouti" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Elfenbeinkueste", label: "Ivory Coast" },
    { value: "ElSalvador", label: "El Salvador" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estland", label: "Estonia" },
    { value: "Fidschi", label: "Fiji" },
    { value: "Finnland", label: "Finland" },
    { value: "Frankreich", label: "France" },
    { value: "Gabun", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgien", label: "Georgia" },
    { value: "Ghana", label: "Ghana" },
    { value: "Gibraltar", label: "Gibraltar" },
    { value: "Grenada", label: "Grenada" },
    { value: "Griechenland", label: "Greece" },
    { value: "Grossbritannien", label: "Great Britain" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guinea", label: "Guinea" },
    { value: "GuineaBissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    { value: "Honduras", label: "Honduras" },
    { value: "Hongkong", label: "Hong Kong" },
    { value: "Indien", label: "India" },
    { value: "Indonesien", label: "Indonesia" },
    { value: "Irak", label: "Iraq" },
    { value: "Iran", label: "Iran" },
    { value: "Irland", label: "Ireland" },
    { value: "Island", label: "Iceland" },
    { value: "Israel", label: "Israel" },
    { value: "Italien", label: "Italy" },
    { value: "Jamaika", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jemen", label: "Yemen" },
    { value: "Jordanien", label: "Jordan" },
    { value: "Kambodscha", label: "Cambodia" },
    { value: "Kamerun", label: "Cameroon" },
    { value: "Kanada", label: "Canada" },
    { value: "KapVerde", label: "Cape Verde" },
    { value: "Kasachstan", label: "Kazakhstan" },
    { value: "Kenia", label: "Kenya" },
    { value: "Kirgisistan", label: "Kyrgyzstan" },
    { value: "Kiribati", label: "Kiribati" },
    { value: "Kolumbien", label: "Columbia" },
    { value: "Komoren", label: "Comoros" },
    { value: "Kongo", label: "Congo" },
    { value: "Kroatien", label: "Croatia" },
    { value: "Kuba", label: "Cuba" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Laos", label: "Laos" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Lettland", label: "Latvia" },
    { value: "Libanon", label: "Lebanon" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libyen", label: "Libya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Litauen", label: "Lithuania" },
    { value: "Luxemburg", label: "Luxembourg" },
    { value: "Madagaskar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Malediven", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marokko", label: "Morocco" },
    { value: "MarshallInseln", label: "Marshall Islands" },
    { value: "Mauretanien", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mexiko", label: "Mexico" },
    { value: "Mikronesien", label: "Micronesia" },
    { value: "Moldawien", label: "Moldova" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolei", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Mosambik", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Neuseeland", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niederlande", label: "Netherlands" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Nordkorea", label: "North Korea" },
    { value: "Norwegen", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Panama", label: "Panama" },
    { value: "PapuaNeuguinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippinen", label: "Philippines" },
    { value: "Polen", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Ruanda", label: "Rwanda" },
    { value: "Rumaenien", label: "Romania" },
    { value: "Russland", label: "Russia" },
    { value: "Sambia", label: "Zambia" },
    { value: "Samoa", label: "Samoa" },
    { value: "SanMarino", label: "San Marino" },
    { value: "SantaLucia", label: "Santa Lucia" },
    { value: "SaoTome", label: "Sao Tome" },
    { value: "SaudiArabien", label: "Saudi Arabia" },
    { value: "Schweden", label: "Sweden" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbien", label: "Serbia" },
    { value: "Seychellen", label: "Seychelles" },
    { value: "SierraLeone", label: "Sierra Leone" },
    { value: "Simbabwe", label: "Zimbabwe" },
    { value: "Singapur", label: "Singapore" },
    { value: "Slowenien", label: "Slovenia" },
    { value: "Somalia", label: "Somalia" },
    { value: "Spanien", label: "Spain" },
    { value: "SriLanka", label: "Sri Lanka" },
    { value: "Suedafrika", label: "South Africa" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suedkorea", label: "South Korea" },
    { value: "Surinam", label: "Surinam" },
    { value: "Syrien", label: "Syria" },
    { value: "Tadschikistan", label: "Tajikistan" },
    { value: "Taiwan", label: "Taiwan" },
    { value: "Tansania", label: "Tanzania" },
    { value: "Thailand", label: "Thailand" },
    { value: "Togo", label: "Togo" },
    { value: "Tonga", label: "Tonga" },
    { value: "TrinidadUndTobago", label: "Trinidad and Tobago" },
    { value: "Tschad", label: "Chad" },
    { value: "Tunesien", label: "Tunisia" },
    { value: "Tuerkei", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "Ungarn", label: "Hungary" },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Usbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    { value: "Vatikanstadt", label: "Vatican City" },
    { value: "Venezuela", label: "Venezuela" },
    { value: "VereinigteArabischeEmirate", label: "United Arab Emirates" },
    { value: "VereinigteStaatenVonAmerica", label: "United States of America" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "ZentralafrikanischeRepublik", label: "Central African Republic" },
    { value: "Zypern", label: "Cyprus" },
  ],
};

interface BusinessFormData {
  formType: string;
  companyName: string;
  companySupplement?: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;
  phone: string;
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  callbackRequested: boolean;
  agbAccepted: boolean;
}

const initialFormData: BusinessFormData = {
  formType: "business-registration",
  companyName: "",
  companySupplement: "",
  street: "",
  houseNumber: "",
  postalCode: "",
  city: "",
  country: "",
  phone: "",
  salutation: "",
  firstName: "",
  lastName: "",
  email: "",
  callbackRequested: false,
  agbAccepted: false,
};

export const BusinessRegistrationForm: React.FC = () => {
  const { t, i18n } = useTranslation("business");
  const [formData, setFormData] = useState<BusinessFormData>(initialFormData);
  const [errors, setErrors] = useState<Record<string, string>>({});

  // Helper function to get dynamic max length for postal code based on country
  const getPostalCodeMaxLength = (country: string): number => {
    if (country === "Deutschland" || country === "Germany") {
      return 5;
    }
    if (country === "Schweiz" || country === "Switzerland") {
      return 4;
    }
    if (
      country === "Oesterreich" ||
      country === "Österreich" ||
      country === "Austria"
    ) {
      return 4;
    }
    // Default for other countries
    return FIELD_LIMITS.postalCode;
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [submissionId, setSubmissionId] = useState<string>("");
  const [apiError, setApiError] = useState("");

  // Get country options based on current language
  const getCountryOptions = () => {
    const currentLang = i18n.language === "en" ? "en" : "de";
    return COUNTRIES[currentLang] || COUNTRIES.de;
  };

  // Get salutation options based on current language
  const getSalutationOptions = () => {
    const isEnglish = i18n.language === "en";
    return [
      { value: "Herr", label: isEnglish ? "Mr" : "Herr" },
      { value: "Frau", label: isEnglish ? "Ms" : "Frau" },
      {
        value: "Neutral",
        label: isEnglish ? "Gender neutral" : "Neutrale Anrede",
      },
    ];
  };

  // Re-validate form when language changes to update error messages
  useEffect(() => {
    // Only re-validate if there are existing errors
    if (Object.keys(errors).length > 0) {
      const newErrors: Record<string, string> = {};

      // Re-check each field that had an error to get the new translated message
      if (errors.companyName && !formData.companyName) {
        newErrors.companyName = t("errors.companyNameRequired");
      }
      if (errors.street && !formData.street) {
        newErrors.street = t("errors.streetRequired");
      }
      if (errors.houseNumber && !formData.houseNumber) {
        newErrors.houseNumber = t("errors.houseNumberRequired");
      }
      if (errors.postalCode && !formData.postalCode) {
        newErrors.postalCode = t("errors.postalCodeRequired");
      }
      if (errors.city && !formData.city) {
        newErrors.city = t("errors.cityRequired");
      }
      if (errors.country && !formData.country) {
        newErrors.country = t("errors.countryRequired");
      }
      if (errors.phone && !formData.phone) {
        newErrors.phone = t("errors.phoneRequired");
      }
      if (errors.salutation && !formData.salutation) {
        newErrors.salutation = t("errors.salutationRequired");
      }
      if (errors.firstName && !formData.firstName) {
        newErrors.firstName = t("errors.firstNameRequired");
      }
      if (errors.lastName && !formData.lastName) {
        newErrors.lastName = t("errors.lastNameRequired");
      }
      if (errors.email) {
        if (!formData.email) {
          newErrors.email = t("errors.emailRequired");
        } else if (!validateEmail(formData.email)) {
          newErrors.email = t("errors.emailInvalid");
        }
      }
      if (errors.agbAccepted && !formData.agbAccepted) {
        newErrors.agbAccepted = t("errors.agbRequired");
      }

      setErrors(newErrors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]); // Re-run when language changes (intentionally limited dependencies)

  // Handle input changes
  const handleInputChange = (
    field: keyof BusinessFormData,
    value: string | boolean
  ) => {
    setFormData((prev) => {
      const updated = {
        ...prev,
        [field]: value,
      };

      return updated;
    });
    // Clear error when user types
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  // Validate Form
  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    // Required field validations
    if (!formData.companyName) {
      newErrors.companyName = t("errors.companyNameRequired");
    } else if (
      !validateMaxLength(formData.companyName, FIELD_LIMITS.companyName)
    ) {
      newErrors.companyName = t("errors.tooLong", {
        max: FIELD_LIMITS.companyName,
      });
    }

    if (!formData.street) {
      newErrors.street = t("errors.streetRequired");
    } else if (!validateMaxLength(formData.street, FIELD_LIMITS.street)) {
      newErrors.street = t("errors.tooLong", { max: FIELD_LIMITS.street });
    }

    if (!formData.houseNumber) {
      newErrors.houseNumber = t("errors.houseNumberRequired");
    } else if (
      !validateMaxLength(formData.houseNumber, FIELD_LIMITS.houseNumber)
    ) {
      newErrors.houseNumber = t("errors.tooLong", {
        max: FIELD_LIMITS.houseNumber,
      });
    }

    if (!formData.postalCode) {
      newErrors.postalCode = t("errors.postalCodeRequired");
    } else if (
      formData.country &&
      !validatePostalCode(formData.postalCode, formData.country)
    ) {
      newErrors.postalCode = t("errors.invalidPostalCode");
    }

    if (!formData.city) {
      newErrors.city = t("errors.cityRequired");
    } else if (!validateMaxLength(formData.city, FIELD_LIMITS.city)) {
      newErrors.city = t("errors.tooLong", { max: FIELD_LIMITS.city });
    }

    if (!formData.country) {
      newErrors.country = t("errors.countryRequired");
    }

    if (!formData.phone) {
      newErrors.phone = t("errors.phoneRequired");
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = t("errors.phoneInvalid");
    } else if (!validateMaxLength(formData.phone, FIELD_LIMITS.phone)) {
      newErrors.phone = t("errors.tooLong", { max: FIELD_LIMITS.phone });
    }

    if (!formData.salutation) {
      newErrors.salutation = t("errors.salutationRequired");
    }

    if (!formData.firstName) {
      newErrors.firstName = t("errors.firstNameRequired");
    } else if (!validateMaxLength(formData.firstName, FIELD_LIMITS.firstName)) {
      newErrors.firstName = t("errors.tooLong", {
        max: FIELD_LIMITS.firstName,
      });
    }

    if (!formData.lastName) {
      newErrors.lastName = t("errors.lastNameRequired");
    } else if (!validateMaxLength(formData.lastName, FIELD_LIMITS.lastName)) {
      newErrors.lastName = t("errors.tooLong", { max: FIELD_LIMITS.lastName });
    }

    if (!formData.email) {
      newErrors.email = t("errors.emailRequired");
    } else if (!validateEmail(formData.email)) {
      newErrors.email = t("errors.emailInvalid");
    } else if (!validateMaxLength(formData.email, FIELD_LIMITS.email)) {
      newErrors.email = t("errors.tooLong", { max: FIELD_LIMITS.email });
    }

    // Optional field validations (only check max length if field has value)
    if (
      formData.companySupplement &&
      !validateMaxLength(
        formData.companySupplement,
        FIELD_LIMITS.companySupplement
      )
    ) {
      newErrors.companySupplement = t("errors.tooLong", {
        max: FIELD_LIMITS.companySupplement,
      });
    }

    if (!formData.agbAccepted) {
      newErrors.agbAccepted = t("errors.agbRequired");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setApiError("");

    try {
      // Add the current language to the form data
      const formDataWithLanguage = {
        ...formData,
        language: i18n.language === "en" ? "en" : "de",
      };

      const result = await submitForm(
        formDataWithLanguage as unknown as Record<string, unknown>
      );
      if (result.success) {
        setSubmissionId(result.id || "");
        setShowSuccess(true);
      }
    } catch (error) {
      // Handle general API error message
      const errorMessage =
        error instanceof Error ? error.message : String(error);

      // Check if error message is the English validation failed message and translate it
      if (errorMessage === "Validation failed. Please check your input.") {
        setApiError(t("errors.validationFailed"));
      } else {
        setApiError(errorMessage || t("errors.submissionFailed"));
      }

      // Handle field-specific validation errors
      interface ErrorWithFieldErrors extends Error {
        fieldErrors?: Record<string, string>;
      }
      if (error instanceof Error && (error as ErrorWithFieldErrors).fieldErrors) {
        const fieldErrors = (error as ErrorWithFieldErrors).fieldErrors;
        const translatedErrors: Record<string, string> = {};

        // Translate field-specific errors
        if (fieldErrors) {
          for (const [field, errorMsg] of Object.entries(fieldErrors)) {
          if (typeof errorMsg === "string") {
            // Map backend error messages to translation keys
            if (
              errorMsg === "Invalid phone number" ||
              errorMsg === "Ungültige Telefonnummer"
            ) {
              translatedErrors[field] = t("errors.invalidPhone");
            } else if (
              errorMsg === "Invalid postal code" ||
              errorMsg === "Ungültige Postleitzahl"
            ) {
              translatedErrors[field] = t("errors.invalidPostalCode");
            } else if (
              errorMsg === "Invalid email address" ||
              errorMsg === "Ungültige E-Mail-Adresse"
            ) {
              translatedErrors[field] = t("errors.emailInvalid");
            } else if (
              errorMsg === "This field is required" ||
              errorMsg === "Dieses Feld ist erforderlich"
            ) {
              translatedErrors[field] = t("errors." + field + "Required");
            } else {
              // Fallback to original message if no translation mapping found
              translatedErrors[field] = errorMsg;
            }
          }
        }
        }

        // Update form errors state to show invalid fields
        setErrors(translatedErrors);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const handleReset = () => {
    setFormData(initialFormData);
    setErrors({});
    setShowSuccess(false);
    setSubmissionId("");
    setApiError("");
  };

  // Show success screen
  if (showSuccess) {
    return (
      <REDSection className="px-8 max-sm:px-4 py-10 shadow-[0_0.125rem_0.25rem_#0000001a] rounded-[4px] db-bg-color-basic-level-1 mb-10">
        <DBNotification
          semantic="successful"
          variant="standalone"
          headline={t("success.title")}
        >
          <p>{t("success.message")}</p>
          <p className="mt-4">
            <strong>
              {t("success.requestNumber")}: {submissionId}
            </strong>
          </p>
        </DBNotification>
        <div className="mt-10 flex justify-end">
          <REDButton
            variant="brand"
            onClick={handleReset}
            className="h-14 px-8"
          >
            {t("success.newForm")}
          </REDButton>
        </div>
      </REDSection>
    );
  }

  return (
    <>
      <REDSection className="pt-6 pb-10 mb-8 px-8 max-sm:px-4 shadow-[0_0.125rem_0.25rem_#0000001a] rounded-[4px] db-bg-color-basic-level-1">
        {apiError && (
          <DBNotification
            semantic="critical"
            variant="standalone"
            className="mb-6"
          >
            {apiError}
          </DBNotification>
        )}

        {/* Company Data Form */}
        <div>
          <h3 className="text-xl font-semibold mb-4">{t("page2.title")}</h3>

          {/* Company Name */}
          <div className="mb-4">
            <REDInput
              label={t("page2.companyName")}
              required
              value={formData.companyName}
              onChange={(e) => handleInputChange("companyName", e.target.value)}
              invalidMessage={errors.companyName}
              validation={errors.companyName ? "invalid" : "no-validation"}
              variant="floating"
              maxLength={FIELD_LIMITS.companyName}
            />
          </div>

          {/* Company Supplement (optional) */}
          <div className="mb-4">
            <REDInput
              label={t("page2.companySupplement")}
              value={formData.companySupplement || ""}
              onChange={(e) =>
                handleInputChange("companySupplement", e.target.value)
              }
              variant="floating"
              maxLength={FIELD_LIMITS.companySupplement}
            />
          </div>

          {/* Street and House Number side by side */}
          <div className="mb-4 flex gap-4">
            {/* Street/P.O.Box - takes up more space */}
            <div className="flex-grow">
              <REDInput
                label={t("page2.street")}
                required
                value={formData.street || ""}
                onChange={(e) => handleInputChange("street", e.target.value)}
                validation={errors.street ? "invalid" : "no-validation"}
                invalidMessage={errors.street}
                variant="floating"
                maxLength={FIELD_LIMITS.street}
              />
            </div>
            {/* House Number - takes up less space */}
            <div className="w-36">
              <REDInput
                label={t("page2.houseNumber")}
                required
                value={formData.houseNumber || ""}
                onChange={(e) =>
                  handleInputChange("houseNumber", e.target.value)
                }
                invalidMessage={errors.houseNumber}
                validation={errors.houseNumber ? "invalid" : "no-validation"}
                variant="floating"
                maxLength={FIELD_LIMITS.houseNumber}
              />
            </div>
          </div>

          {/* Postal Code and City */}
          <div className="mb-4 flex gap-4">
            {/* Postal Code - takes up less space (1/3) */}
            <div className="w-36">
              <REDInput
                label={t("page2.postalCode")}
                required
                value={formData.postalCode}
                onChange={(e) =>
                  handleInputChange("postalCode", e.target.value)
                }
                invalidMessage={errors.postalCode}
                validation={errors.postalCode ? "invalid" : "no-validation"}
                variant="floating"
                maxLength={getPostalCodeMaxLength(formData.country)}
              />
            </div>
            {/* City - takes up more space (2/3) */}
            <div className="flex-grow">
              <REDInput
                label={t("page2.city")}
                required
                value={formData.city}
                onChange={(e) => handleInputChange("city", e.target.value)}
                invalidMessage={errors.city}
                validation={errors.city ? "invalid" : "no-validation"}
                variant="floating"
                maxLength={FIELD_LIMITS.city}
              />
            </div>
          </div>

          {/* Country */}
          <div className="mb-4">
            <REDCustomSelect
              label={t("page2.country")}
              required
              variant="floating"
              values={formData.country ? [formData.country] : []}
              onOptionSelected={(event) => {
                let value = "";
                if (Array.isArray(event)) {
                  value = event[0] || ""; // Take first element if it's an array
                }
                handleInputChange("country", value);
              }}
              options={getCountryOptions()}
              validation={errors.country ? "invalid" : "no-validation"}
              invalidMessage={errors.country}
              placeholder={t("page2.selectCountry")}
            />
          </div>

          {/* Contact Person Section */}
          <h3 className="text-xl font-semibold mb-4 mt-8">
            {t("page2.contactPersonTitle")}
          </h3>

          {/* Salutation */}
          <div className="mb-4">
            <REDCustomSelect
              label={t("page2.salutation")}
              required
              variant="floating"
              values={formData.salutation ? [formData.salutation] : []}
              onOptionSelected={(event) => {
                let value = "";
                if (Array.isArray(event)) {
                  value = event[0] || "";
                }
                handleInputChange("salutation", value);
              }}
              options={getSalutationOptions()}
              validation={errors.salutation ? "invalid" : "no-validation"}
              invalidMessage={errors.salutation}
              placeholder={t("page2.selectSalutation")}
            />
          </div>

          {/* First Name and Last Name side by side */}
          <div className="mb-4 flex gap-4">
            {/* First Name */}
            <div className="flex-1">
              <REDInput
                label={t("page2.firstName")}
                required
                value={formData.firstName}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
                invalidMessage={errors.firstName}
                validation={errors.firstName ? "invalid" : "no-validation"}
                variant="floating"
                maxLength={FIELD_LIMITS.firstName}
              />
            </div>
            {/* Last Name */}
            <div className="flex-1">
              <REDInput
                label={t("page2.lastName")}
                required
                value={formData.lastName}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
                invalidMessage={errors.lastName}
                validation={errors.lastName ? "invalid" : "no-validation"}
                variant="floating"
                maxLength={FIELD_LIMITS.lastName}
              />
            </div>
          </div>

          {/* Phone */}
          <div className="mb-4">
            <REDInput
              label={t("page2.phone")}
              required
              type="tel"
              value={formData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              invalidMessage={errors.phone}
              validation={errors.phone ? "invalid" : "no-validation"}
              variant="floating"
              maxLength={FIELD_LIMITS.phone}
              placeholder="+49 30 12345678"
            />
          </div>

          {/* Email */}
          <div className="mb-4">
            <REDInput
              label={t("page2.email")}
              required
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              invalidMessage={errors.email}
              validation={errors.email ? "invalid" : "no-validation"}
              variant="floating"
              maxLength={FIELD_LIMITS.email}
            />
          </div>

          {/* Legal Agreements */}
          {/* Checkbox 1: bahn.business AGB */}
          <div className="mb-4 mt-8">
            <REDCheckbox
              checked={formData.agbAccepted}
              validation={errors.agbAccepted ? "invalid" : "no-validation"}
              invalidMessage={errors.agbAccepted}
              onChange={(e) =>
                handleInputChange("agbAccepted", e.target.checked)
              }
            >
              <span dangerouslySetInnerHTML={{ __html: t("page2.agbText") }} />
            </REDCheckbox>
          </div>

          {/* Callback Option (optional) */}
          <div className="mb-6">
            <REDCheckbox
              checked={formData.callbackRequested}
              onChange={(e) =>
                handleInputChange("callbackRequested", e.target.checked)
              }
            >
              {t("page2.callbackOption")}
            </REDCheckbox>
          </div>

          {/* Submit Button */}
          <div className="flex justify-end mt-8">
            <REDButton
              className="h-14 px-8"
              variant="brand"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? t("page2.submitting") : t("page2.submit")}
            </REDButton>
          </div>
        </div>
      </REDSection>
      <p
        className="max-[1200px]:pl-4 text-[14px] mb-6 db-on-bg-color-emphasis-70"
        aria-hidden="true"
      >
        <span>*</span> {t("requiredFields")}
      </p>
    </>
  );
};
